import DentiraLogo from './../../../assets/icons/dentira.svg';

export const DentiraIcon = DentiraLogo;
